/**
 * Mode gửi trả
 */
export default {
  Receive: 1,
  Examine: 2,
};
